const returnCodes = [
    'Value_BetterPrice',
    'CustPref_DoesNotSuit',
    'CustPref_DoesNotLikeColour',
    'CustPref_DoesNotLikeMaterial',
    'CustPref_ChangedMind',
    'Product_DoNotLike',
    'Product_PoorQuality',
    'Service_TooLate',
]

const sharedReturnCodes = ['Size_TooLoose', 'Size_TooTight', 'Size_Compare', 'Service_WrongItem', 'Service_FaultyItem']

export const filterReasonOptions = (returnOrExchange, reasonOptions) => {
    if (returnOrExchange === 'exchange') {
        return reasonOptions
    } else {
        return reasonOptions?.filter(
            (option) => returnCodes.includes(option.key) || sharedReturnCodes.includes(option.key)
        )
    }
}
